import Cookies from 'js-cookie'
import { getFetchRequest } from './fetcher'
import { API_TYPES } from './logs'
import type { IRefreshTokenResponse } from '@/root/types/auth-api'
import { logNewRelicEvent } from '@/root/utils/common/custom/newrelic-page-events'
import { IError } from '@/root/utils/network-adapter/types'
import { HTTP_STATUS_CODE } from '@/root/constants/api-status-codes'
import { devLog } from '@/root/utils/devLogger'
import { COOKIE_KEYS } from '@/root/utils/auth/cookies'

export const onMpinRequired = (navLink: string) => {
  // Status 424 is for 2FA journey
  if (
    typeof window === 'object' &&
    !window.location.pathname.includes('journey/2fa') &&
    navLink
  ) {
    const url = new URL(navLink)

    const search = new URLSearchParams(url.search)

    const currUrl = new URL(window.location.href)

    search.append(
      'return_to',
      encodeURIComponent(currUrl.pathname + currUrl.search).substring(0, 1000),
    )

    window.location.href = `${url.pathname}?${search.toString()}`
  }
}

const safeGetRefreshedToken = async () => {
  logNewRelicEvent('refresh_token_called', {
    traceId: Cookies.get('trace_id') ?? '',
    refreshToken: !!Cookies.get('refresh_token'),
  })
  const refreshPromise = getFetchRequest({
    url: '/api/auth/refresh-token',
    config: {
      headers: {
        'Content-Type': 'application/json',
      },
    },
    apiType: API_TYPES.refreshTokenApi,
  }).then(async (data: IRefreshTokenResponse) => {
    logNewRelicEvent('refresh_token_success', {
      traceId: Cookies.get('trace_id') ?? '',
      authCode: !!data?.auth_code,
    })
    return {
      authCode: data?.auth_code,
      backendStatus: data?.backend_status,
    }
  })

  return refreshPromise
}

export const getRefreshedTokenFromServer = async () => {
  const response = await safeGetRefreshedToken().catch(
    async (error: unknown) => {
      const traceId = Cookies.get(COOKIE_KEYS.TRACE_ID) ?? ''

      devLog('error from refresh token---', error, JSON.stringify(error))
      if ((error as IError)?.statusCode === HTTP_STATUS_CODE.BAD_REQUEST) {
        logNewRelicEvent('refresh_token_fallback_called', {
          traceId,
        })
        return null
      } else throw error
    },
  )
  return response
}
